import React from 'react';

export default function IntrauterineInsemination() {
  return (
    <main className="section-container py-12">
      <div className="space-y-8">
        <section>
          <h1 className="text-4xl font-bold text-brand mb-6">
            Intrauterine Insemination (IUI)
          </h1>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Intrauterine Insemination also known as artificial insemination is a simple, easy and natural treatment for some couples with infertility. In the course of natural conception, semen is deposited in the vagina after the act of intercourse. Sperms have to travel upto the site of fertilization (ampulla of fallopian tube) and pregnancy is possible only of this intercourse has occurred around the time of ovulation.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            In Intrauterine Insemination, two factors: timing of insemination and distance that sperm has to travel are controlled and this increase the chances of conception two fold over the couples baseline chances.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-brand mb-4">Which couples are fit for undergoing IUI?</h2>
          <ul className="list-disc list-inside space-y-2 text-neutral/70">
            <li>Couples with unexplained infertility</li>
            <li>Women with normal ovarian reserve</li>
            <li>Couples with mild male factor infertility</li>
            <li>Couples with coital issues</li>
            <li>Couples with minimal or mild endometriosis</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-brand mb-4">Which couples should not opt for IUI?</h2>
          <ul className="list-disc list-inside space-y-2 text-neutral/70">
            <li>Couples who have already undergone three or more cycles of IUI</li>
            <li>Women with blocked tubes</li>
            <li>Women with reduced ovarian reserve</li>
            <li>Couples with severe male factor infertility</li>
            <li>Couples with moderate or severe endometriosis</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-brand mb-4">How is IUI done?</h2>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Woman is required to report during menses when a baseline sonography is done and tablets and or injections are administered to induce development of follicles. The growth of these follicles is monitored with ultrasound. When the follicle reaches a size of 18 to 20 mm, trigger injection is given to induce rupture of the follicle and release of the egg within the follicle. Around 36 hours after the trigger injection, IUI is planned. Husband is required to give a semen sample on the day of IUI by masturbation. This sample is prepared in the lab using special culture media to remove dead and immotile sperms and optimize the quality of sperms. This sample is inserted in the uterus. Insemination is a painless process and done without anesthesia. After insemination, patient can do all their normal activities and bed rest is not needed.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-brand mb-4">Success rate of IUI</h2>
          <p className="text-neutral/70 leading-relaxed">
            IUI success rates vary between 10 to 15% per cycle and depend on age, ovarian reserve, duration of infertility, semen parameters and tubal status Dr. Priya Bhave Chittawar has done extensive research on IUI and her research paper on Factors predicting IUI success has been published in national and international journals.
          </p>
          <p className="text-neutral/70 leading-relaxed mt-2">
            <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3017328/" className="text-brand hover:underline" target="_blank" rel="noopener noreferrer">
                https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3017328/
            </a>
          </p>
          <p className="text-neutral/70 leading-relaxed mt-2">
            <a href="https://www.ncbi.nlm.nih.gov/pubmed/23083636" className="text-brand hover:underline" target="_blank" rel="noopener noreferrer">
                https://www.ncbi.nlm.nih.gov/pubmed/23083636
            </a>
          </p>
        </section>
      </div>
    </main>
  );
}
